<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Messages
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>Add your creative messages</span>
          </v-tooltip>
        </h1>
<!--        <messages-breadcrumbs-->
<!--          :breadcrumbs="breadcrumbs"-->
<!--        />-->
        <transition name="messages" mode="out-in">
          <component
            v-if="!dialog"
            :is="selectedPath"
            :selectedIssue="selectedIssue"
            :issues="issues"
            :messages="messages"
            :message="message"
            @openDialog="openDialog"
            @setBreadcrumbs="setBreadcrumbs"
            @setConfirmActive="setConfirmActive"
            @setMessageFields="setMessageFields"
            @copyMessage="copyMessage"
            @editMessage="editMessage"
            @selectCreativePath="selectCreativePath"
          />
        </transition>

        <transition name="dialog" mode="in-out">
          <message-selector
            v-if="dialog"
            @closeDialog="closeDialog"
            @selectCreativePath="selectCreativePath"
          />
        </transition>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row v-if="selectedPath === 'overview' && !dialog">
        <v-btn @click="previousPage">Previous</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!next"
          @click="nextPage"
        >Next</v-btn>
      </v-row>
      <v-row v-if="selectedPath !== 'overview' && !dialog">
        <v-btn @click="closeDialog">Cancel</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          v-if="selectedPath !== 'confirmation-page' && !dialog && !createOrUpdateSelector"
          :disabled="!confirmActive"
          @click="createMessage"
        >
          Create
        </v-btn>
        <v-btn
          color="primary"
          v-if="createOrUpdateSelector"
          :disabled="!confirmActive"
          @click="updateMessage"
        >
          Update
        </v-btn>
        <!--<v-btn-->
          <!--v-else-->
          <!--color="primary"-->
          <!--@click="createMessage"-->
        <!--&gt;Confirm</v-btn>-->
      </v-row>
    </div>
  </v-container>
</template>

<script>
import lodash from 'lodash'
import helpers from '../../../helpers/functions'
import Overview from './paths/messages-overview/Index.vue'
import CreateAd from './paths/create-ad/Index.vue'
import VideoAd from './paths/video/Index.vue'
import PromotePost from './paths/promote-post/Index.vue'
import UseTemplate from './paths/use-template/Index.vue'
import GetHelp from './paths/get-help/Index.vue'
import ConfirmationPage from './paths/confirmation/Index.vue'
import MessageSelector from './MessageSelector.vue'
import MessagesBreadcrumbs from './MessagesBreadcrumbs.vue'
export default {
  name: 'messages',
  components: {
    MessageSelector,
    Overview,
    CreateAd,
    VideoAd,
    PromotePost,
    UseTemplate,
    GetHelp,
    ConfirmationPage,
    MessagesBreadcrumbs
  },
  data () {
    return {
      next: true,
      dialog: false,
      selectedPath: 'overview',
      selectedIssue: {},
      breadcrumbs: [],
      confirmActive: false,
      message: {},
      timeout: null
    }
  },
  props: {
    issues: {
      type: Array,
      default: () => []
    },
    messages: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.initNewMessage()
  },
  computed: {
    createOrUpdateSelector () {
      return this.message.edit
    },
    setupMode () {
      const setupMode = this.$store.getters.getSetupMode
      return setupMode ? setupMode.status : false
    }
  },
  methods: {
    getPreview () {
      if (this.setupMode || !this.checkAdblock()) return false
      // Note: clear preview
      this.message.previewLoading = true
      const params = {
        description: this.message.description,
        link: this.message.url,
        image_url: this.message.externalUrl || 'https://app.outfox.ai/static/img/of-logo.ba20680.png',
        hash: this.message.image_hash || null,
        caption: this.message.displayLink,
        message: this.message.text,
        name: this.message.headline,
        file: this.message.file,
        callToAction: this.message.callToAction.split(' ').join('_'),
        political: this.message.political ? 'POLITICAL' : '',
        video: this.message.selectedVideo
      }
      helpers.getMessagePreview(params)
        .then(res => {
          const arr = res.split(' ')
          this.message.preview = `${arr[0]} ${arr[1]} scrolling="no" width=auto height=auto></iframe>`
          this.timeout = setTimeout(() => {
            this.message.previewLoading = false
            clearTimeout(this.timeout)
          }, 3000)
        })
    },
    checkAdblock () {
      const allowedIframeId = ['intercom-frame']
      if (document.querySelector("iframe") && !allowedIframeId.find(i => i === document.querySelector("iframe").id)) {
        if (document.querySelector("iframe").clientHeight === 0) {
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['<div>It appears like you are using an ad blocker. Please disable it for this site to see a preview of your ad.</div>']
          })
          return false
        }
      }
      return true
    },
    selectCreativePath (path) {
      this.selectedPath = path
      this.dialog = false
    },
    openDialog (issue) {
      this.dialog = true
      this.selectedIssue = issue
    },
    closeDialog () {
      this.dialog = false
      this.selectedPath = 'overview'
      this.selectedIssue = {}
      this.breadcrumbs = []
      this.initNewMessage()
    },
    setBreadcrumbs (breadcrumbs) {
      this.breadcrumbs = breadcrumbs
    },
    setConfirmActive (status) {
      this.confirmActive = status
    },
    nextPage () {
      this.$emit('next')
    },
    previousPage () {
      this.$emit('previous')
    },
    confirm () {
      if (this.selectedPath !== 'confirmation-page') {
        this.selectedPath = 'confirmation-page'
      }
    },
    setMessageFields (value, field, preview) {
      this.message[field] = value
      if (preview) {
        this.getPreview()
      }
    },
    initNewMessage () {
      this.message = {
        edit: false,
        reviewFileUrl: null,
        file: null,
        preview: '',
        previewLoading: false,
        description: '',
        externalUrl: null,
        image_hash: null,
        url: 'https://www.democrats.org/',
        text: 'Enter your ad text here',
        headline: 'My New Facebook Ad',
        displayLink: '',
        name: 'My message name',
        callToAction: 'LEARN MORE',
        political: false,
        urlParams: '',
        selectedVideo: null
      }
    },
    createMessage () {
      const payload = Object.assign(this.message,
        {
          issue: this.selectedIssue.name
        })
      this.$emit('createMessage', payload)
      this.selectedPath = 'overview'
      this.initNewMessage()
    },
    copyMessage (message) {
      this.$emit('createMessage', message)
      this.initNewMessage()
    },
    editMessage (message) {
      const newMessage = lodash.cloneDeep(message)
      newMessage.edit = true
      this.message = newMessage
      this.selectedPath = 'create-ad'
    },
    updateMessage () {
      const clonnedMessage = lodash.cloneDeep(this.message)
      clonnedMessage.edit = false
      this.$emit('updateMessage', clonnedMessage)
      this.initNewMessage()
      this.selectedPath = 'overview'
    }
  }
}
</script>
<style scoped>
  .messages-enter-active {
    transition: transform .3s ease;
  }
  .messages-enter {
    transform: translateX(1500px);
  }
  .dialog-enter-active {
    transition: transform .3s ease;
  }
  .dialog-enter {
    transform: translateX(500px);
    opacity: 0;
  }
</style>
